import { z } from "zod";
import moment from "moment";
import { Form } from "src/components/common/form";
import { Input } from "src/components/common/form/input";
import { Select } from "src/components/common/form/select";
import { Button } from "react-bootstrap";
import { useBusSchedulesQuery } from "src/services/react-query-apis/get-bus-schedules";
import { getJpWeekDay } from "src/utils/formatdate";
import { useFormContext } from "react-hook-form";

const busRidingListFilterSchema = z.object({
  attendance_date: z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/, "日付を入力してください"),
  bus_schedule_id: z.coerce
    .number()
    .min(1, "バススケジュールを選択してください"),
});

export const BusRidingListFilter = ({ onSubmit }) => {
  return (
    <Form
      onSubmit={values => {
        onSubmit(values);
      }}
      schema={busRidingListFilterSchema}
      options={{
        defaultValues: {
          attendance_date: moment().format("YYYY-MM-DD"),
          bus_schedule_id: 0,
        },
      }}
    >
      {({ register, formState }) => {
        return (
          <>
            <div className="d-flex gap-2 flex-wrap">
              <Input
                type="date"
                label="日付"
                name="attendance_date"
                error={formState.errors["attendance_date"]}
                registration={register("attendance_date")}
              />
              <BusScheduleSelect />
            </div>
            <div className="d-flex">
              <Button type="submit">検索</Button>
            </div>
          </>
        );
      }}
    </Form>
  );
};

const BusScheduleSelect = () => {
  const { register, watch, formState } = useFormContext();

  const attendanceDate = watch("attendance_date");

  const month = moment(attendanceDate).format("YYYY-MM");

  const busSchedulesQuery = useBusSchedulesQuery({
    month,
    queryConfig: {
      enabled: !!watch("attendance_date"),
    },
  });

  let scheduleOptions = [{ value: 0, label: "選択してください" }];

  if (busSchedulesQuery.data?.data) {
    scheduleOptions = [
      ...scheduleOptions,
      ...busSchedulesQuery.data?.data
        .filter(
          schedule =>
            schedule.day_week === getJpWeekDay(watch("attendance_date"))
        )
        .map(schedule => ({
          value: schedule.id,
          label: `${schedule.description}`,
        })),
    ];
  }

  return (
    <Select
      label="バススケジュール"
      options={scheduleOptions}
      name="bus_schedule_id"
      error={formState.errors["bus_schedule_id"]}
      registration={register("bus_schedule_id")}
      readOnly={!watch("attendance_date")}
    />
  );
};
